<template>
  <v-dialog v-model="dialog" fullscreen>
    <v-card>
      <v-toolbar card color="green lighten-2">
        <v-toolbar-title>SETTINGS</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat icon @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container grid-list-xl>
        <v-layout>
          <v-flex>
            <v-card>
              <v-tabs v-model="active" color="grey lighten-2">
                <v-tab @click="generalTab">General</v-tab>
                <v-tab @click="acountTab">Account</v-tab>
                <v-tab-item>
                  <v-container>
                    <v-layout justify-center>
                      <v-flex md9>
                        <v-layout
                          align-start
                          justify-center
                          :class="[showName ? 'grey lighten-4 ' : '', 'mx-0']"
                        >
                          <v-flex md3>
                            <strong>Name</strong>
                          </v-flex>
                          <v-flex v-if="!showName" md7>
                            {{
                            employee.first_name + " " + employee.last_name
                            }}
                          </v-flex>
                          <v-flex v-else md7>
                            <v-layout>
                              <v-flex>
                                <v-form v-model="valid" ref="form1" lazy-validation>
                                  <v-text-field
                                    v-model="employee.first_name"
                                    label="First Name"
                                    required
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                  <v-text-field
                                    v-model="employee.last_name"
                                    label="Last Name"
                                    required
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                </v-form>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-spacer></v-spacer>
                              <v-btn @click="saveName" class="primary">save</v-btn>
                              <v-btn @click="cancelName">cancel</v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex md1>
                            <a v-if="!showName" @click="(showName = !showName), cancelEmail()">EDIT</a>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout
                          align-start
                          justify-center
                          :class="[showEmail ? 'grey lighten-4 ' : '', 'mx-0']"
                        >
                          <v-flex md3>
                            <strong>Email Address</strong>
                          </v-flex>
                          <v-flex v-if="!showEmail" md7>
                            {{
                            employee.email
                            }}
                          </v-flex>
                          <v-flex v-else md7>
                            <v-layout>
                              <v-flex>
                                <v-form v-model="valid" ref="form2" lazy-validation>
                                  <v-text-field
                                    v-model="employee.email"
                                    label="Email Address"
                                    required
                                    :rules="[rules.required, rules.email]"
                                  ></v-text-field>
                                </v-form>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-spacer></v-spacer>
                              <v-btn @click="saveEmail" class="primary">save</v-btn>
                              <v-btn @click="cancelEmail">cancel</v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex md1>
                            <a
                              v-if="!showEmail"
                              @click="(showEmail = !showEmail), cancelName()"
                            >EDIT</a>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
                <v-tab-item>
                  <v-container>
                    <v-layout justify-center>
                      <v-flex md9>
                        <v-layout
                          align-start
                          justify-center
                          :class="[showUsername ? 'grey lighten-4 ' : '', 'mx-0']"
                        >
                          <v-flex md3>
                            <strong>Username</strong>
                          </v-flex>
                          <v-flex v-if="!showUsername" md7>
                            {{
                            user.username
                            }}
                          </v-flex>
                          <v-flex v-else md7>
                            <v-layout>
                              <v-flex>
                                <v-form v-model="valid" ref="form3" lazy-validation>
                                  <v-text-field
                                    v-model="user.username"
                                    label="Username"
                                    required
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                </v-form>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-spacer></v-spacer>
                              <v-btn @click="saveUsername" class="primary">save</v-btn>
                              <v-btn @click="cancelUsername">cancel</v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex md1>
                            <a
                              v-if="!showUsername"
                              @click="
                            (showUsername = !showUsername), cancelPassword()
                          "
                            >EDIT</a>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout
                          align-start
                          justify-center
                          :class="[showPassword ? 'grey lighten-4 ' : '', 'mx-0']"
                        >
                          <v-flex md3>
                            <strong>Change Password</strong>
                          </v-flex>
                          <v-flex v-if="!showPassword" md7></v-flex>
                          <v-flex v-else md7>
                            <v-layout>
                              <v-flex>
                                <v-form v-model="valid" ref="form" lazy-validation>
                                  <v-text-field
                                    v-model="currentPassword"
                                    label="Current Password"
                                    type="password"
                                    required
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                  <v-text-field
                                    v-model="newPassword"
                                    label="New Password"
                                    type="password"
                                    required
                                    :rules="[rules.required]"
                                  ></v-text-field>
                                  <v-text-field
                                    v-model="retypePassword"
                                    label="Re-type new Password"
                                    type="password"
                                    required
                                    :rules="[rules.required, rules.match]"
                                  ></v-text-field>
                                </v-form>
                              </v-flex>
                            </v-layout>
                            <v-layout>
                              <v-spacer></v-spacer>
                              <v-btn @click="savePassword" class="primary">save</v-btn>
                              <v-btn @click="cancelPassword">cancel</v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex md1>
                            <a
                              v-if="!showPassword"
                              @click="
                            (showPassword = !showPassword), cancelUsername()
                          "
                            >EDIT</a>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import Services from "@/services/Services";
export default {
  data() {
    return {
      active: null,
      employee: {},
      user: {},
      showName: false,
      showEmail: false,
      showUsername: false,
      showPassword: false,
      currentPassword: null,
      newPassword: null,
      retypePassword: null,
      valid: true,
      dialog: false,
      rules: {
        required: value => !!value || "This field is required.",
        match: value => value === this.newPassword || "Password Not Match.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  created: function() {
    // this.setData();
  },
  methods: {
    async openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async setData() {
      var data = {};

      try {
        const response = await Services.getAccountEmployee();
        data = await response.data;
        // data.first_name = data.first_name;
        // data.last_name = data.last_name;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.employee = await data;

      await this.$store.dispatch("dispatchEmployee", {
        first_name: this.employee.first_name,
        last_name: this.employee.last_name,
        email: this.employee.email
      });
    },
    async setUser() {
      var data = {};

      try {
        const response = await Services.getAccountUser();
        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.user = await data;
    },
    async generalTab() {
      this.cancelName();
      this.cancelEmail();
    },
    async acountTab() {
      this.cancelUsername();
      this.cancelPassword();
    },
    async saveName() {
      if (this.$refs.form1.validate()) {
        try {
          const response = await Services.editEmployee(
            {
              first_name: this.employee.first_name,
              last_name: this.employee.last_name
            },
            this.employee.id
          );
          console.log(response.status);

          if (response.status === 201 || response.status === 204) {
            this.cancelName();
            this.$infoBar({
              type: "success",
              text: "Name has been updated!"
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "Server Error!"
            });
          }
        } catch (error1) {
          if (!error1.response) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            if (error1.response.status === 422) {
              this.$infoBar({
                type: "error",
                text: `${this.$capitalizeFirstLetter(
                  error1.response.data.column
                )} already exist!`
              });
            }
          }
        }
      }
    },
    async cancelName() {
      await this.setData();
      this.showName = false;
    },
    async saveEmail() {
      if (this.$refs.form2.validate()) {
        try {
          const response = await Services.editEmployee(
            {
              email: this.employee.email
            }
            // this.employee.id
          );
          console.log(response.status);

          if (response.status === 201 || response.status === 204) {
            await this.cancelEmail();
            this.$infoBar({
              type: "success",
              text: "Email has been updated!"
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "Server Error!"
            });
          }
        } catch (error1) {
          if (!error1.response) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            if (error1.response.status === 422) {
              this.$infoBar({
                type: "error",
                text: `Email address already exist!`
              });
            }
          }
        }
      }
    },
    async cancelEmail() {
      await this.setData();
      this.showEmail = false;
    },
    async saveUsername() {
      if (this.$refs.form3.validate()) {
        try {
          const response = await Services.editUser(
            {
              username: this.user.username
            },
            this.user.id
          );
          console.log(response.status);

          if (response.status === 201 || response.status === 204) {
            await this.cancelUsername();
            this.$infoBar({
              type: "success",
              text: "Username has been updated!"
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "Server Error!"
            });
          }
        } catch (error1) {
          if (!error1.response) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            if (error1.response.status === 422) {
              this.$infoBar({
                type: "error",
                text: `${this.$capitalizeFirstLetter(
                  error1.response.data.column
                )} already exist!`
              });
            }
          }
        }
      }
    },
    async cancelUsername() {
      await this.setUser();
      this.showUsername = false;
    },
    async savePassword() {
      if (this.$refs.form.validate()) {
        try {
          const response = await Services.editUser(
            {
              password: this.currentPassword,
              new_password: this.newPassword
            },
            this.user.id
          );
          console.log(response.status);

          if (response.status === 201 || response.status === 204) {
            this.cancelPassword();
            this.$infoBar({
              type: "success",
              text: "Password has been updated!"
            });
          } else {
            this.$infoBar({
              type: "error",
              text: "Server Error!"
            });
          }
        } catch (error1) {
          if (!error1.response) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            if (error1.response.status === 403) {
              this.$infoBar({
                type: "error",
                text: error1.response.data.error
              });
            }
          }
        }
      }
    },
    async cancelPassword() {
      await this.setUser();
      if (this.showPassword) this.$refs.form.reset();
      this.showPassword = false;
    }
  }
};
</script>
